import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/Advisors";

function Advisors({ position = "", positionType = "Producer", defaultSections = [] }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={defaultSections}
			cacheManagement={{
				clearAbsoluteIndexes: ["payPlanCsiMetrics", "payPlansSidebarTree"],
			}}
			instantCreation
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
Advisors.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
	defaultSections: PropTypes.arrayOf(PropTypes.string),
};

export default Advisors;
